module.exports = __webpack_public_path__ + "media/info/blue-info-blue-ring-9121fa65.svg";